import Enhancer from '../enhancer';
import EnhancerApp from '../enhancer-app';

export default class Form extends Enhancer {

    invalidFormClassName = 'needs-validation';
    validatedFormClassName = 'was-validated';

    init() {

        if (this.formElement.classList.contains(this.invalidFormClassName)) {
            this.element.scrollIntoView();
            this.vaidationSummaryElement.focus();
        }
        else if (this.successMessageIsDisplayed) {
            this.element.scrollIntoView();
        }

    }

    get formElement() {
        return this.get('form');
    }

    get vaidationSummaryElement() {
        return this.get('.validation-summary-errors');
    }

    get successMessageIsDisplayed() {
        return this.get('.form-success-message') != null;
    }

}

EnhancerApp.register('Form', Form);